
import React, { useRef, useMemo }from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { AgGridReact as AgGridReactType } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 100%;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    type: string;
    attribute: string;
    rows: SingleRow[];
    columns: ColDef[];
    height: string;
    setApplyEnabled: (value: boolean) => void;
    selectionMode: string;
}

export const DataGrid: React.FC<Props> = ({
    type,
    rows,
    columns,
    height,
    setApplyEnabled,
    selectionMode
}) => {
    const grid = useRef<AgGridReactType>(null);
   
    const onSelectionChanged = (params) => {
        const selection = params.api.getSelectedRows()
        apiProvider.setPathFilterSelectedData({ selection, type });
        setApplyEnabled(!!selection.length);
    };

    const onFirstDataRendered  = (params) => {
        const allColumnIds = [];
        params.api.getAllGridColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
    };

    React.useEffect(() => {
        const listener = () => {
         if (grid != null) {
             grid.current.api.forEachNode((rowNode) => {rowNode.setSelected(false)});
         };
     };
     apiProvider.on(Event.resetFilter, listener);

     return () => {
         apiProvider.off(Event.resetFilter, listener);
     };
 }, []);    

    const getRowHeight = (params) => params.node.group ? 24 : 24;
    return (
        <Wrapper height={height}>
            <div
                
                style={{
                    height: '100%',
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}
            >
                {selectionMode === 'multiple' ?
                <AgGridReact theme={themeAlpine} 
                    rowSelection="multiple"
                    onSelectionChanged={onSelectionChanged}
                    onFirstDataRendered={onFirstDataRendered}
                    columnDefs={columns}
                    headerHeight={40}
                    rowData={rows}
                    ref={grid}
                    getRowHeight={getRowHeight} />
                :
                <AgGridReact theme={themeAlpine} 
                    rowSelection="single"
                    onSelectionChanged={onSelectionChanged}
                    onFirstDataRendered={onFirstDataRendered}
                    columnDefs={columns}
                    headerHeight={40}
                    rowData={rows}
                    ref={grid}
                    getRowHeight={getRowHeight} />
                }
            </div>
        </Wrapper>
    );
};
